import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from '../../api/client';
import { apiErrorText } from '../../api/errorText';

/// Changing one's own password. The password in use is asked for as well, because it is what
/// says the person typing is the person whose account it is rather than somebody who walked
/// past an unlocked screen.
export default function ChangePassword() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string>();
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const mismatch = repeat.length > 0 && next !== repeat;
  const ready = current.length > 0 && next.length > 0 && !mismatch;

  const save = async () => {
    setBusy(true);
    setError(undefined);
    setDone(false);

    try {
      await api.changeMyPassword(current, next);

      setCurrent('');
      setNext('');
      setRepeat('');
      setDone(true);
    } catch (caught) {
      setError(apiErrorText(caught, t).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Box>
            <Typography variant="h3">{t('preferences.password')}</Typography>
            <Typography variant="body2" color="text.secondary">
              {t('preferences.passwordHint')}
            </Typography>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}
          {done && <Alert severity="success">{t('preferences.passwordChanged')}</Alert>}

          <TextField
            label={t('preferences.currentPassword')}
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(event) => setCurrent(event.target.value)}
          />

          <TextField
            label={t('preferences.newPassword')}
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(event) => setNext(event.target.value)}
          />

          <TextField
            label={t('setup.account.confirm')}
            type="password"
            autoComplete="new-password"
            value={repeat}
            error={mismatch}
            helperText={mismatch ? t('setup.account.mismatch') : undefined}
            onChange={(event) => setRepeat(event.target.value)}
          />

          <Box>
            <Button variant="contained" disabled={!ready || busy} onClick={() => void save()}>
              {t('common.save')}
            </Button>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
